import { render, staticRenderFns } from "./MungBeanAllocateDetailList.vue?vue&type=template&id=f73d465e&scoped=true&lang=pug&"
import script from "./MungBeanAllocateDetailList.vue?vue&type=script&lang=ts&"
export * from "./MungBeanAllocateDetailList.vue?vue&type=script&lang=ts&"
import style0 from "./MungBeanAllocateDetailList.vue?vue&type=style&index=0&id=f73d465e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73d465e",
  null
  
)

export default component.exports